export default "./dist/stdassets/images/icons/edit-copy.png";